import styled from '@emotion/styled';
import { HStack } from '@lib/uikit';
import capitalize from '@utils/string/capitalize';

import { Select } from './hooks/useVariantSelects';
import { OptionLabel } from './OptionLabel';

const RadioInput = styled.label`
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    background: ${({ theme }) => theme.palette.grey[100]};
    color: ${({ theme }) => theme.palette.grey[900]};
    border-radius: ${({ theme }) => theme.shape.radius.xs};
    padding-inline: ${({ theme }) => theme.spacing.sm};
    padding-block: ${({ theme }) => theme.spacing.xs};
    &:has(input:checked) {
        background: ${({ theme }) => theme.palette.grey[900]};
        color: ${({ theme }) => theme.palette.grey[50]};
    }
    &:has(input:disabled) {
        background: ${({ theme }) => theme.palette.grey[200]};
        color: ${({ theme }) => theme.palette.grey[400]};
        cursor: not-allowed;
    }
`;

export const VariantRadioSelect = ({
    select,
    onSelectOption,
}: {
    select: Select;
    onSelectOption: (
        optionName: string,
        value?: string,
        isFinal?: boolean
    ) => void;
}) => {
    return (
        <HStack spacing='xs' alignItems='start'>
            <OptionLabel>{capitalize(select.name)}</OptionLabel>
            <HStack
                width='100%'
                justifyContent='left'
                spacing='xs'
                flexWrap='wrap'
                rowSpacing='xxs'
            >
                {select.options.map((option) => (
                    <RadioInput
                        key={option.value}
                        // IMPROVEME: Overriding native radio behavior to allow deselect is not fully semantic.
                        onClick={(e) => {
                            e.preventDefault();
                            if (option.disabled) return;
                            onSelectOption(
                                select.name,
                                option.value === select.value
                                    ? undefined
                                    : option.value,
                                select.isFinal
                            );
                        }}
                    >
                        <input
                            readOnly
                            type='radio'
                            name={select.name}
                            value={option.value}
                            disabled={option.disabled}
                            checked={select.value === option.value}
                            style={{ display: 'none' }}
                        />
                        {option.label ?? capitalize(option.value)}
                    </RadioInput>
                ))}
            </HStack>
        </HStack>
    );
};
